import React from 'react';
import PropTypes from 'prop-types';
import ReactPlaceholder from 'react-placeholder';

import {
	Grid,
	makeStyles
} from '@material-ui/core';

import Avatar from './Avatar.js';

const styles = makeStyles(theme => ({
	content: {
		paddingLeft: theme.spacing(3)
	},

	avatarItem: {
		maxWidth: "10%"
	}
}));

function AvatarRowWithCol(props) {
	let classes = styles(),
		{authorName, fidoError, contentClassName, className, useIconFallback, ready,
			authorImage, primary, forceInitials, children} = props;

	return (
		<Grid
			container
			wrap="nowrap"
			direction="row"
			justify="flex-start"
			className={className}>
			<Grid
				item
				className={classes.avatarItem}
				xs={1} sm={1} md={1} lg={1} xl={1}>
				<ReactPlaceholder
					type='round'
					ready={ready}
					style={{width: 48, height: 48}}>
					<Avatar
						authorName={authorName}
						authorImage={authorImage}
						useIconFallback={useIconFallback}
						primary={primary}
						forceInitials={forceInitials} />
				</ReactPlaceholder>
			</Grid>
			<Grid
				item
				xs={11} sm={11} md={11} lg={11} xl={11}
				className={`${classes.content} ${contentClassName}`}>
				{children}
			</Grid>
		</Grid>
	);
}

AvatarRowWithCol.propTypes = {
	children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
	className: PropTypes.string,
	contentClassName: PropTypes.string,
	authorName: PropTypes.string,
	authorImage: PropTypes.string,
	primary: PropTypes.bool,
	forceInitials: PropTypes.bool,
	fidoError: PropTypes.bool,
	useIconFallback: PropTypes.bool,
	ready: PropTypes.bool
};

export default AvatarRowWithCol;
